module.exports = __webpack_public_path__ + "static/img/ba.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ba.png
// module id = HpAQ
// module chunks = 52